import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../../data/content";

export const EditorialMarquee = () => {
  return (
    <div className="relative py-10 border-y border-white/5 bg-white/[0.01] overflow-hidden" data-testid="marquee">
      <Marquee speed={26} gradient={false} autoFill pauseOnHover={false}>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-4xl md:text-6xl font-light tracking-tight text-stroke px-8">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-brand/70" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
